import {
  Box,
  Button,
  Chip,
  Divider,
  Grid2,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { Calculate } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ClayBrickDetails = ({ mainData, setMainData, isNonMobile }) => {
  const handleFieldUpdate = (serialNo, field, value) => {
    setMainData((prev) => ({
      ...prev,
      labTestsDataFromSubs: prev.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, [field]: value } : test,
      ),
    }));
  };
  return (
    <Box justifyItems="center">
      <Paper variant="elevation" elevation={2} sx={{ padding: "10px" }}>
        <Box
          display="grid"
          gap={0.5}
          alignItems="center"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 4",
            },
          }}
        >
          <Typography
            sx={{ gridColumn: "span 4" }}
            color="warning"
            variant="h4"
            textAlign="center"
          >
            CHECKING THE DIMENSION
          </Typography>
          <Divider sx={{ margin: "5px 0px", gridColumn: "span 4" }} />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            variant="h6"
            textAlign="center"
          >
            DETENSION
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            SPECIMAN DIMENSION
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            OVERALL DIMENSION
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            SATISFACTORY
          </Typography>
          <Divider sx={{ gridColumn: "span 4", margin: "2px 0px" }} />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            Length (mm)
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={mainData.length}
            onChange={(e) =>
              setMainData((pre) => ({
                ...pre,
                length: e.target.value,
              }))
            }
          />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            5,280 ± 75
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            // color={chartData.spec50pass ? "success" : "error"}
            textAlign="center"
            variant="h6"
          >
            {mainData.lengthPass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            Width (mm)
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={mainData.weight}
            onChange={(e) =>
              setMainData((pre) => ({
                ...pre,
                weight: e.target.value,
              }))
            }
          />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            2,520 ± 40
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color={mainData.widthPass ? "success" : "error"}
            textAlign="center"
            variant="h6"
          >
            {mainData.widthPass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            Height (mm)
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={mainData.height}
            onChange={(e) =>
              setMainData((pre) => ({
                ...pre,
                height: e.target.value,
              }))
            }
          />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            1,560 ± 40
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color={mainData.heightPass ? "success" : "error"}
            textAlign="center"
            variant="h6"
          >
            {mainData.heightPass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
          </Typography>
          <Divider sx={{ gridColumn: "span 4", margin: "20px 0px" }} />
          <Typography
            sx={{ gridColumn: "span 4" }}
            color="warning"
            variant="h4"
            textAlign="center"
          >
            WATER ABSORPTION
          </Typography>
          <Divider sx={{ margin: "5px 0px", gridColumn: "span 4" }} />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            variant="h6"
            textAlign="center"
          >
            SAMPLE NO
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            WEIGHT BEFORE SOAKING
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            AFTER SOAKING
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            WATER ABSORPTION %
          </Typography>
          <Divider sx={{ gridColumn: "span 4", margin: "10px 0px" }} />
        </Box>

        {mainData.labTestsDataFromSubs?.map((data, index) => (
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            key={index}
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 4",
              },
            }}
          >
            <Typography
              variant="h5"
              textAlign="center"
              sx={{ gridColumn: "span 1", margin: "12px 0px" }}
            >
              {data.serialNo === undefined ? "AUTO" : data.serialNo}
            </Typography>

            <TextField
              value={data.weight}
              fullWidth
              variant="outlined"
              label="WEIGHT BEFORE SOAKING"
              onChange={(e) =>
                handleFieldUpdate(data.serialNo, "weight", e.target.value)
              }
              type="number"
              size="small"
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />

            <TextField
              value={data.compressiveStrength}
              fullWidth
              variant="outlined"
              label="AFTER SOAKING"
              type="number"
              size="small"
              // onChange={(e) =>
              //   handleCompressiveStrength(data.serialNo, e.target.value)
              // }
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />
            <TextField
              value={data.compressiveStrength}
              fullWidth
              variant="outlined"
              label="WATER ABSORPTION %"
              type="number"
              size="small"
              // onChange={(e) =>
              //   handleCompressiveStrength(data.serialNo, e.target.value)
              // }
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />
          </Box>
        ))}

        <Divider sx={{ margin: "25px 0px" }} />
        <Box
          display="grid"
          gap={0.5}
          alignItems="center"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 4",
            },
          }}
        >
          <Typography
            sx={{ gridColumn: "span 4" }}
            color="warning"
            variant="h4"
            textAlign="center"
          >
            COMPRESSIVE STRENGTH
          </Typography>
          <Divider sx={{ margin: "5px 0px", gridColumn: "span 4" }} />
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            variant="h6"
            textAlign="center"
          >
            SAMPLE NO
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            LOAD (kN)
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            AREA (mm²)
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h6"
          >
            COMPRESSIVE STRENGTH (N/mm²)
          </Typography>
        </Box>
        {mainData.labTestsDataFromSubs?.map((data, index) => (
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 4",
              },
            }}
          >
            <Typography
              variant="h5"
              textAlign="center"
              sx={{ gridColumn: "span 1", margin: "12px 0px" }}
            >
              {data.serialNo === undefined ? "AUTO" : data.serialNo}
            </Typography>

            <TextField
              value={data.weight}
              fullWidth
              variant="outlined"
              label="LOAD (kN)"
              // onChange={(e) =>
              //   handleSetWeight(data.serialNo, e.target.value)
              // }
              type="number"
              size="small"
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />

            <TextField
              value={data.compressiveStrength}
              fullWidth
              variant="outlined"
              label="AREA (mm²)"
              type="number"
              size="small"
              // onChange={(e) =>
              //   handleCompressiveStrength(data.serialNo, e.target.value)
              // }
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />
            <TextField
              value={data.compressiveStrength}
              fullWidth
              variant="outlined"
              label="COM.STRENGTH (N/mm²)"
              type="number"
              size="small"
              // onChange={(e) =>
              //   handleCompressiveStrength(data.serialNo, e.target.value)
              // }
              sx={{
                "& input": {
                  textAlign: "right",
                },
                gridColumn: "span 1",
              }}
            />
          </Box>
        ))}

        <Divider sx={{ marginTop: "10px" }} />
        <Button
          variant="contained"
          color="success"
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
          startIcon={<Calculate />}
          // onClick={calculationOfChart}
        >
          Calculate
        </Button>
      </Paper>
    </Box>
  );
};

export default ClayBrickDetails;
